import * as pdfjsLib from 'pdfjs-dist/webpack'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'


pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker
pdfjsLib.isOffscreenCanvasSupported = false


export async function decryptFile(encryptedBlob, jwkKey, blob=true) {
    // Parse the JWK key as an object
    let keyObject = JSON.parse(jwkKey);

    // Extract the IV from the JWK key object
    var iv = new Uint8Array(Object.values(keyObject.iv));
    delete keyObject.iv;

    // Import the key
    const key = await window.crypto.subtle.importKey(
        "jwk",
        keyObject,
        {
            name: "AES-GCM",
            length: 256,
        },
        true,
        ["decrypt"]
    );

    // Read the encrypted file as an ArrayBuffer
    const encryptedData = await new Response(encryptedBlob).arrayBuffer();

    // Decrypt the data
    const decryptedData = await window.crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        encryptedData
    );

    // Return the decrypted data as a new Blob
    if(blob){
        console.log("???")
        return new Blob([decryptedData], {type: encryptedBlob.type});
    }

    return decryptedData;

}

export async function encryptFile(decryptedBlob, jwkKey, blob=true) {
    
     // Parse the JWK key as an object
     let keyObject = JSON.parse(jwkKey);

     // Extract the IV from the JWK key object
     var iv = new Uint8Array(Object.values(keyObject.iv));
     delete keyObject.iv;
 
     // Import the key
     const key = await window.crypto.subtle.importKey(
         "jwk",
         keyObject,
         {
             name: "AES-GCM",
             length: 256,
         },
         true,
         ["encrypt"]
     );

     var decryptedData = await new Response(decryptedBlob).arrayBuffer();

      // Decrypt the data
    const encryptedData = await window.crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        decryptedData
    );

    if(blob){
        return new Blob([encryptedData]);
    }
    return encryptedData;
}

